export default __webpack_public_path__ + "static/media/PosterEverythingFinal14.4028cc06.jpg";